import { forwardRef } from 'react'

import Link from '@mui/material/Link'
import Box, { BoxProps } from '@mui/material/Box'
import RouterLink from '../router-link'
// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const logo = (
      <Box
        ref={ref}
        component='div'
        sx={{
          display: 'flex',
          alignItems: 'center',
          ...sx,
        }}
        {...other}
      >
        <Box
          component='img'
          src='/assets/img/logo.png'
          alt='iClub.ai Logo'
          sx={{ width: 60, maxHeight: 60 }}
        />
      </Box>
    )

    if (disabledLink) {
      return logo
    }

    return (
      <Link component={RouterLink} href='/' sx={{ display: 'contents' }}>
        {logo}
      </Link>
    )
  },
)

export default Logo
